import { Box, Circle, Flex, Image, List, ListItem, Text } from '@chakra-ui/react';
import React from 'react';

export interface ProcessFeatureProps {
  index: string;
  title: string;
  iconUrl: string;
  contents: string[];

  // OPTIONAL
  description?: string;
}

const ProcessFeature = ({
  index,
  title,
  iconUrl,
  contents,

  // OPTIONAL
  description,
}: ProcessFeatureProps) => (
  <Box mx="auto">
    <Box
      color="white"
      fontSize="1.3rem"
      fontWeight="700"
      lineHeight="1"
      mx="auto"
      textAlign="center"
    >
      STEP
      <br />
      <Text fontSize="2.8rem" lineHeight="1.2" mb="0.5rem">
        {index}
      </Text>
    </Box>
    <Circle
      size={{ base: `9rem`, md: `12rem` }}
      mx="auto"
      mb={6}
      bg="white"
      color="white"
    >
      <Flex flexDir="column" justify="center" align="center">
        <Image src={iconUrl} alt={title} w="90%" mb="0.2rem" />
        <Box
          color="brand.900"
          fontSize="1.3rem"
          fontWeight="800"
          mx="auto"
          textAlign="center"
        >
          <p>{title}</p>
        </Box>
      </Flex>
    </Circle>
    {description ? (
      <Box
        textAlign="center"
        mx="auto"
        bg="brand.900"
        p="0.5rem"
        color="white"
        pos="relative"
        borderRadius="3xl"
        top={{ base: `-2.75rem`, md: `-3rem` }}
        fontSize="1.2rem"
        w={{ base: `63%`, md: `50%` }}
      >
        <Text mt="0.25rem">{description}</Text>
      </Box>
    ) : (
      <Box
        textAlign="center"
        mx="auto"
        p="0.75rem"
        color="white"
        pos="relative"
        top={{ base: `-2.75rem`, md: `-3rem` }}
        fontSize="1.2rem"
        w={{ base: `63%`, md: `50%` }}
      />
    )}
    <Box
      textAlign="center"
      mx="auto"
      mt="1rem"
      p="0.5rem"
      color="gray.300"
      pos="relative"
      borderRadius="20px"
      top="-3rem"
      fontSize={{ base: `0.9rem`, md: `1.1rem` }}
      w="100%"
    >
      <List spacing={2}>
        {contents.map((content) => (
          <ListItem key={content}>{content}</ListItem>
        ))}
      </List>
    </Box>
  </Box>
);

export default ProcessFeature;
